import { FC, useContext, useEffect, useState } from 'react';
import { RegistrationsContext } from '../../../../context/contextProvider';
import useIsMounted from '../../../../hooks/useIsMounted';
import { Registration } from '../../../../types/registrationTypes';
import DevicesForm from './containers/devicesForm';

interface Props {
  registration?: Registration | null;
  updateRegistration: (registration: Registration) => Promise<Registration>;
  preventSwitchTabDueToUnsavedData: (value: boolean) => void;
  disabled: boolean;
  registrationIsCompleted: boolean;
}

const RegistrationDevices: FC<Props> = ({ registration, updateRegistration, preventSwitchTabDueToUnsavedData, disabled, registrationIsCompleted }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const isMounted = useIsMounted();
  const { devices: deviceContext } = useContext(RegistrationsContext);
  const devicesData = deviceContext.devices;
  const [refreshCounter, setRefreshCounter] = useState<number>(0);

  useEffect(() => {
    if (!devicesData) {
      deviceContext.fetchDevices();
    }
  }, [devicesData, deviceContext]);

  const updateDevices = async (registration: Registration): Promise<Registration> => {
    setLoading(true);
    try {
      if (registration?.id) {
        await updateRegistration({
          ...registration
        });
      }
    } catch (e) {
      throw e;
    } finally {
      if (isMounted) {
        setLoading(false);
      }
      setRefreshCounter(refreshCounter+1)
    }

    throw new Error('Something went wrong, registration is missing id');
  };

  return (
    <DevicesForm
      key={'devices-form-'+refreshCounter}
      preventSwitchTabDueToUnsavedData={preventSwitchTabDueToUnsavedData}
      registration={registration}
      updateDevices={updateDevices}
      loading={loading}
      unregisteredDevices={devicesData}
      disabled={disabled}
      registrationIsCompleted={registrationIsCompleted}
    />
  );
};

export default RegistrationDevices;
